<script lang="ts">
  import { usePopoverContext } from '../use-popover-context';
  import { css } from '@agapi/ui/panda/css';
  import type { PopoverTriggerProps } from '../popover.types';

  let buttonRef: HTMLButtonElement;

  const popover = usePopoverContext();

  const { children, onmouseenter, onmouseleave, onblur, css: cssProp }: PopoverTriggerProps = $props();


  function onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      onblur?.();
    }
  }
</script>

<button
  {...popover.api.getTriggerProps()}
  bind:this={buttonRef}
  onmouseenter={onmouseenter}
  onmouseleave={onmouseleave}
  onkeydown={onKeyDown}
  class={css(cssProp)}
>
  {#if children}
    {@render children()}
  {/if}
</button>
